import React from 'react';
import { CnLayoutSection as UICnLayoutSection } from '@cainiaofe/cn-ui';
import { getSlotDom, getExtraDom, getExtraProps } from './util';
import { getBizExtendProps } from '@/common/manager/plugin';
import './view.scss';
const CnLayoutSection = (props) => {
    const { children, _layout } = props || {};
    const { componentSlot } = _layout || {};
    const extraDom = getExtraDom(props);
    const slotDom = getSlotDom(componentSlot);
    const extraProps = getExtraProps(props);
    const realProps = {
        ...getBizExtendProps({
            componentName: 'CnLayoutSection',
            props,
        }),
        ...extraProps,
    };
    return (<UICnLayoutSection extra={extraDom} {...realProps}>
      {slotDom}
      {children}
    </UICnLayoutSection>);
};
CnLayoutSection.displayName = 'CnLayoutSection';
export default CnLayoutSection;
export { CnLayoutSection };
